import {
  Button as AIMEButton,
  Input as AIMEInput,
} from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import Navbar from "./Navbar";

export default function Adminreferralsfive() {
  return (
    <RootWrapperAdminreferralsfive>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <AdminMenu>
              <AIMEButton
                size="small"
                onClick={() => alert("Referrals clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                  borderRadius: "8px",
                  alignSelf: "stretch",
                  background: "rgb(97, 98, 197)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "white",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Referrals
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Waitlist clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Waitlist
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Members clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Members
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Payments clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Payments
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Dispute clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Dispute
                </span>
              </AIMEButton>

              <Frame1438>
                <Vendors>Vendors</Vendors>
              </Frame1438>

              <AIMEButton
                size="small"
                onClick={() => alert("All Vendors clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  All Vendors
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Recommendations clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Recommendations
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Featured Vendors clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Featured Vendors
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Categories - Industry Sector clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Categories - Industry Sector
                </span>
              </AIMEButton>

              <Frame1437>
                <Frame1437_0001>
                  <WebsiteContent>Website Content</WebsiteContent>
                </Frame1437_0001>
              </Frame1437>

              <AIMEButton
                size="small"
                onClick={() => alert("Vendors on Home clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Vendors on Home
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Trusted Vendors on Home clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Trusted Vendors on Home
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("FAQ’s clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  FAQ’s
                </span>
              </AIMEButton>

              <Frame1438>
                <Admin>Admin</Admin>
              </Frame1438>

              <AIMEButton
                size="small"
                onClick={() => alert("Analytics clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Analytics
                </span>
              </AIMEButton>

              <AIMEButton
                size="small"
                onClick={() => alert("Admin - accounts clicked")}
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                  alignSelf: "stretch",
                  background: "rgb(255, 255, 255)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  boxSizing: "border-box",
                  padding: "12px 16px",
                  flexShrink: "0",
                }}
              >
                <span
                  style={{
                    color: "rgb(33, 37, 67)",
                    textOverflow: "ellipsis",
                    fontSize: "16px",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: "500",
                    lineHeight: "22px",
                    textAlign: "left",
                  }}
                >
                  Admin - accounts
                </span>
              </AIMEButton>
            </AdminMenu>
          </Left_0001>
          <Right>
            <Frame1545>
              <DashboardHeader>
                <Frame1462>
                  <LinkButton>
                    <AIMEButton
                      size="small"
                      onClick={() => alert("Back clicked")}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "row",
                        alignItems: "center",
                        flex: "none",
                        gap: "4px",
                        borderRadius: "4px",
                        boxSizing: "border-box",
                        padding: "8px 12px",
                      }}
                    >
                      <span
                        style={{
                          color: "rgb(100, 116, 139)",
                          textOverflow: "ellipsis",
                          fontSize: "14px",
                          fontFamily: "Montserrat, sans-serif",
                          fontWeight: "600",
                          lineHeight: "140%",
                          textAlign: "left",
                        }}
                      >
                        Back
                      </span>
                    </AIMEButton>
                  </LinkButton>
                  <WelcomeJames>Referral Details # [R234567]</WelcomeJames>
                </Frame1462>
              </DashboardHeader>
              <MemberStatusTags>
                <Tracking>Resolved</Tracking>
              </MemberStatusTags>
            </Frame1545>
            <Frame1555>
              <Frame1552>
                <ReferralStatusMember>
                  Referral Status: Member
                </ReferralStatusMember>
                <Frame1571>
                  <Notifiaton1>
                    <Frame1428
                      src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/5096f0ab-bd9f-46b5-b584-bc2711769c2a"
                      alt="icon"
                    />
                    <Frame1435>
                      <Frame1545_0001>
                        <_2Apr2025>2-Apr-2025</_2Apr2025>
                        <_1010Am>- 10:10am</_1010Am>
                      </Frame1545_0001>
                      <Frame1437>
                        <Frame1547_0001>
                          <Tracking_0001>Tracking</Tracking_0001>
                        </Frame1547_0001>
                      </Frame1437>
                    </Frame1435>
                  </Notifiaton1>
                  <LinkButton>
                    <AIMEButton
                      size="small"
                      onClick={() => alert("Change Status clicked")}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "row",
                        alignItems: "center",
                        flex: "none",
                        gap: "4px",
                        borderRadius: "4px",
                        boxSizing: "border-box",
                        padding: "8px 12px",
                      }}
                    >
                      <span
                        style={{
                          color: "rgb(97, 98, 197)",
                          textOverflow: "ellipsis",
                          fontSize: "14px",
                          fontFamily: "Montserrat, sans-serif",
                          fontWeight: "600",
                          lineHeight: "140%",
                          textAlign: "left",
                        }}
                      >
                        Change Status
                      </span>
                    </AIMEButton>
                  </LinkButton>
                </Frame1571>
              </Frame1552>
              <Frame1555_0001>
                <ReferralStatusVendor>
                  Referral Status: Vendor
                </ReferralStatusVendor>
                <Frame1571>
                  <Notifiaton1>
                    <Frame1428
                      src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/c08d4173-ae0d-4c07-b546-9ef58cd6c30b"
                      alt="icon"
                    />
                    <Frame1435>
                      <Frame1545_0001>
                        <_1Apr2025>4-Apr-2025</_1Apr2025>
                        <_1010Am>- 10:10am</_1010Am>
                      </Frame1545_0001>
                      <Frame1546>
                        <ReferralSubmitted>Proposal Sent</ReferralSubmitted>
                      </Frame1546>
                    </Frame1435>
                  </Notifiaton1>
                  <LinkButton_0002>
                    <AIMEButton
                      size="small"
                      onClick={() => alert("Change Status clicked")}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "row",
                        alignItems: "center",
                        flex: "none",
                        gap: "4px",
                        borderRadius: "4px",
                        boxSizing: "border-box",
                        padding: "8px 12px",
                      }}
                    >
                      <span
                        style={{
                          color: "rgb(97, 98, 197)",
                          textOverflow: "ellipsis",
                          fontSize: "14px",
                          fontFamily: "Montserrat, sans-serif",
                          fontWeight: "600",
                          lineHeight: "140%",
                          textAlign: "left",
                        }}
                      >
                        Change Status
                      </span>
                    </AIMEButton>
                  </LinkButton_0002>
                </Frame1571>
              </Frame1555_0001>
            </Frame1555>
            <Frame1558>
              <Frame1566>
                <Frame1565>
                  <Frame1564>
                    <Dispute345678>Dispute #345678</Dispute345678>
                    <Created23March2025>
                      Created: 23-March,2025
                    </Created23March2025>
                  </Frame1564>
                </Frame1565>
                <MemberStatusTags>
                  <Tracking>Resolved</Tracking>
                </MemberStatusTags>
              </Frame1566>
              <DisputeMessage>
                <Frame1568>
                  <Frame1566>
                    <Frame1566_0001>
                      <Frame1564_0001
                        src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/063648c8-1c47-4c1e-b936-e5d85f6d82bd"
                        alt="icon"
                      />
                      <Frame1565_0001>
                        <JohnnyDepp>Johnny Depp</JohnnyDepp>
                        <Member>Member</Member>
                      </Frame1565_0001>
                    </Frame1566_0001>
                    <_23March20251015Am>
                      23-March,2025 - 10:15am
                    </_23March20251015Am>
                  </Frame1566>
                  <ThisIsAMessageForTheMemberWhoFacedSomeIssuesFromTheReferralsSideHeIsClaimingHisRewardsAndSaysThatAmountReceivedDoesNotMatchTheOneMentionedInTheEmail>
                    This is a message for the member who faced some issues from
                    the referrals side. He is claiming his rewards and says that
                    amount received does not match the one mentioned in the
                    email.
                  </ThisIsAMessageForTheMemberWhoFacedSomeIssuesFromTheReferralsSideHeIsClaimingHisRewardsAndSaysThatAmountReceivedDoesNotMatchTheOneMentionedInTheEmail>
                </Frame1568>
              </DisputeMessage>
            </Frame1558>
            <Frame1559>
              <Frame1581>
                <MemberProfile>Member Profile</MemberProfile>
                <LinkButton>
                  <AIMEButton
                    size="small"
                    onClick={() => alert("View Member Profile clicked")}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      gap: "4px",
                      borderRadius: "4px",
                      boxSizing: "border-box",
                      padding: "8px 12px",
                    }}
                  >
                    <span
                      style={{
                        color: "rgb(97, 98, 197)",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "140%",
                        textAlign: "left",
                      }}
                    >
                      View Member Profile
                    </span>
                  </AIMEButton>
                </LinkButton>
              </Frame1581>
              <Frame1485>
                <Frame1538>
                  <ContactPerson>Contact Person</ContactPerson>
                  <JohnnyDepp_0001>Johnny Depp</JohnnyDepp_0001>
                </Frame1538>
                <Frame1539>
                  <ContactNumber>Contact Number</ContactNumber>
                  <_441234567789>+44 123 4567 789</_441234567789>
                </Frame1539>
                <Frame1540>
                  <EmailAddress>Email address</EmailAddress>
                  <JamesdoeGmailCom>jamesdoe@gmail.com</JamesdoeGmailCom>
                </Frame1540>
                <Frame1541>
                  <SubmittedOn>Submitted on</SubmittedOn>
                  <_1Apr20251010Am>1-Apr-2025 10:10am</_1Apr20251010Am>
                </Frame1541>
              </Frame1485>
            </Frame1559>
            <Frame1485_0001>
              <Frame1555>
                <Frame1468>
                  <Frame1484>
                    <ReferralsDetails>Referrals Details</ReferralsDetails>
                    <LinkButton>
                      <AIMEButton
                        size="small"
                        onClick={() => alert("Edit Details clicked")}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "row",
                          alignItems: "center",
                          flex: "none",
                          gap: "4px",
                          borderRadius: "4px",
                          boxSizing: "border-box",
                          padding: "8px 12px",
                        }}
                      >
                        <span
                          style={{
                            color: "rgb(97, 98, 197)",
                            textOverflow: "ellipsis",
                            fontSize: "14px",
                            fontFamily: "Montserrat, sans-serif",
                            fontWeight: "600",
                            lineHeight: "140%",
                            textAlign: "left",
                          }}
                        >
                          Edit Details
                        </span>
                      </AIMEButton>
                    </LinkButton>
                  </Frame1484>
                  <Frame1476>
                    <CompanyWebsite>Company Website</CompanyWebsite>
                    <WwwGreenleafcafeCo>
                      www.greenleafcafe.co
                    </WwwGreenleafcafeCo>
                  </Frame1476>
                  <Frame1473>
                    <Frame1470>
                      <Frame1476>
                        <Sector>Sector</Sector>
                        <TechnologySoftwareSaaS>
                          Technology / Software / SaaS
                        </TechnologySoftwareSaaS>
                      </Frame1476>
                    </Frame1470>
                    <Frame1470>
                      <Frame1476>
                        <Location>Location</Location>
                        <LondonUk>London, UK</LondonUk>
                      </Frame1476>
                    </Frame1470>
                  </Frame1473>
                  <Frame1476>
                    <DoesYourFriendHaveABudgetToWorkTo>
                      Does your friend have a budget to work to ?
                    </DoesYourFriendHaveABudgetToWorkTo>
                    <Unknown>Unknown</Unknown>
                  </Frame1476>
                  <Frame1476>
                    <IsYouFriendADecisionMaker>
                      Is you friend a decision maker
                    </IsYouFriendADecisionMaker>
                    <Yes>Yes</Yes>
                  </Frame1476>
                  <Frame1476>
                    <DoesYourFriendHaveAnUrgentProblemOrNeedToAddress>
                      Does your friend have an urgent problem or need to
                      address?
                    </DoesYourFriendHaveAnUrgentProblemOrNeedToAddress>
                    <SelectedOption>[selected option]</SelectedOption>
                  </Frame1476>
                  <Frame1476>
                    <InWhatTimeframeWillTheyNeedASolution>
                      In what timeframe will they need a solution?
                    </InWhatTimeframeWillTheyNeedASolution>
                    <SelectedOption>[selected option]</SelectedOption>
                  </Frame1476>
                  <Frame1483_0001>
                    <Frame1483_0002>
                      <PleaseShareAnyRelevantContextOfYourReferral>
                        Please share any relevant context of your referral
                      </PleaseShareAnyRelevantContextOfYourReferral>
                    </Frame1483_0002>
                    <Frame1472>
                      <AddSomeNotesHere>
                        Add some notes here...
                      </AddSomeNotesHere>
                    </Frame1472>
                  </Frame1483_0001>
                </Frame1468>
                <Frame1580>
                  <ActivityNotification>
                    <Frame1583>
                      <Frame1435_0002>
                        <Reward>Reward</Reward>
                        <_200>£200</_200>
                      </Frame1435_0002>
                      <Frame1434>
                        <AmountAtTheTimeOfSubmission>
                          Amount at the time of submission
                        </AmountAtTheTimeOfSubmission>
                      </Frame1434>
                    </Frame1583>
                    <Frame1476>
                      <SubmittedOn_0001>Submitted on:</SubmittedOn_0001>
                      <_19January2025181025>
                        19 January 2025, 18: 10: 25
                      </_19January2025181025>
                    </Frame1476>
                  </ActivityNotification>
                  <Right_0001>
                    <PRTNR.Input label="Expected Close Date" />

                    <InternalNotes>
                      <Frame1437>
                        <Frame1433_0001>
                          <InternalNotes_0001>
                            Internal Notes
                          </InternalNotes_0001>
                        </Frame1433_0001>
                      </Frame1437>
                      <PrtnrTextarea>
                        <GFieldsStacked_0001>
                          <AIMEInput type="text" placeholder="" />
                        </GFieldsStacked_0001>
                      </PrtnrTextarea>
                    </InternalNotes>
                  </Right_0001>
                </Frame1580>
              </Frame1555>
              <Frame1471_0001>
                <Frame1484_0001>
                  <Frame1484_0002>
                    <ReferralsDetails_0001>
                      Vendor Profile
                    </ReferralsDetails_0001>
                  </Frame1484_0002>
                </Frame1484_0001>
                <Frame1485_0002>
                  <Frame1538_0001>
                    <SubmittedToVendor>Submitted to Vendor</SubmittedToVendor>
                    <Nesti>Nesti</Nesti>
                  </Frame1538_0001>
                  <Frame1539_0001>
                    <SubmittedOn>Submitted on</SubmittedOn>
                    <Frame1551>
                      <_1Apr2025_0001>3-Apr-2025</_1Apr2025_0001>
                      <_1010Am_0002>04:10pm</_1010Am_0002>
                    </Frame1551>
                  </Frame1539_0001>
                  <LinkButton>
                    <AIMEButton
                      size="small"
                      onClick={() => alert("View Vendor Profile clicked")}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "row",
                        alignItems: "center",
                        flex: "none",
                        gap: "4px",
                        borderRadius: "4px",
                        boxSizing: "border-box",
                        padding: "8px 12px",
                      }}
                    >
                      <span
                        style={{
                          color: "rgb(97, 98, 197)",
                          textOverflow: "ellipsis",
                          fontSize: "14px",
                          fontFamily: "Montserrat, sans-serif",
                          fontWeight: "600",
                          lineHeight: "140%",
                          textAlign: "left",
                        }}
                      >
                        View Vendor Profile
                      </span>
                    </AIMEButton>
                  </LinkButton>
                </Frame1485_0002>
              </Frame1471_0001>
              <ActivityNotification_0001>
                <Frame1433_0002>
                  <History>History</History>
                </Frame1433_0002>
                <ActivitesList>
                  <Frame1428
                    src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/79718484-d30a-4fee-9e6f-ecbae592e3a4"
                    alt="icon"
                  />
                  <Frame1435_0003>
                    <Frame5>
                      <Frame1519>
                        <StatusChangedTo>Status changed to:</StatusChangedTo>
                        <ProposalSent>
                          Admin added contact information
                        </ProposalSent>
                      </Frame1519>
                      <_2Apr2025>2-Apr-2025</_2Apr2025>
                    </Frame5>
                    <Frame1551>
                      <Note>Note:</Note>
                      <LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry>
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry.
                      </LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry>
                    </Frame1551>
                  </Frame1435_0003>
                </ActivitesList>
                <Notifiaton1_0002>
                  <Frame1428
                    src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/7458ae96-9a72-4477-9cce-1c5825717db8"
                    alt="icon"
                  />
                  <Frame1435_0004>
                    <Frame1545_0001>
                      <_2Apr2025>2-Apr-2025</_2Apr2025>
                      <_1010Am>- 10:10am</_1010Am>
                    </Frame1545_0001>
                    <Frame1547_0002>
                      <Frame1547_0003>
                        <Tracking_0003>Tracking</Tracking_0003>
                      </Frame1547_0003>
                    </Frame1547_0002>
                  </Frame1435_0004>
                </Notifiaton1_0002>
                <Notifiaton1_0002>
                  <Frame1428
                    src="https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/93a43fe2-99cc-4981-a3bb-bb4689ae76f2"
                    alt="icon"
                  />
                  <Frame1435_0004>
                    <Frame1545_0001>
                      <_1Apr2025>1-Apr-2025</_1Apr2025>
                      <_1010Am>- 10:10am</_1010Am>
                    </Frame1545_0001>
                    <Frame1546>
                      <ReferralSubmitted>Referral submitted</ReferralSubmitted>
                    </Frame1546>
                  </Frame1435_0004>
                </Notifiaton1_0002>
              </ActivityNotification_0001>
            </Frame1485_0001>
          </Right>
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>
    </RootWrapperAdminreferralsfive>
  );
}

const RootWrapperAdminreferralsfive = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 12px;
  width: 1200px;
  box-sizing: border-box;
  padding: 24px 16px;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Logo = styled.div`
  width: 165px;
  height: 24px;
  position: relative;
`;

const Logo1 = styled.div`
  width: 166px;
  height: 24px;
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
`;

const Vector = styled.svg`
  width: 16px;
  height: 19px;
  position: absolute;
  left: 34px;
  top: 2px;
  right: 116px;
  bottom: 2px;
`;

const Vector_0001 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 52px;
  top: 6px;
  right: 98px;
  bottom: 2px;
`;

const Vector_0002 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 70px;
  top: 6px;
  right: 79px;
  bottom: 2px;
`;

const Vector_0003 = styled.svg`
  width: 10px;
  height: 16px;
  position: absolute;
  left: 90px;
  top: 6px;
  right: 66px;
  bottom: 2px;
`;

const Vector_0004 = styled.svg`
  width: 11px;
  height: 20px;
  position: absolute;
  left: 101px;
  top: 2px;
  right: 54px;
  bottom: 2px;
`;

const Vector_0005 = styled.svg`
  width: 15px;
  height: 16px;
  position: absolute;
  left: 114px;
  top: 6px;
  right: 37px;
  bottom: 2px;
`;

const Vector_0006 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 131px;
  top: 6px;
  right: 19px;
  bottom: 2px;
`;

const Vector_0007 = styled.svg`
  width: 10px;
  height: 16px;
  position: absolute;
  left: 149px;
  top: 6px;
  right: 7px;
  bottom: 2px;
`;

const Vector_0008 = styled.svg`
  width: 4px;
  height: 4px;
  position: absolute;
  left: 161px;
  top: 6px;
  right: 1px;
  bottom: 14px;
`;

const Group1 = styled.div`
  width: 25px;
  height: 24px;
  position: absolute;
  left: 0px;
  top: 0px;
`;

const Image19 = styled.div`
  width: 25px;
  height: 24px;
  background: url(https://s3-alpha-sig.figma.com/img/4b35/a886/422bef44a2225fae3321414ad27d07ab?Expires=1748822400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=nP6F2KWp3ZX3N92kOes4bArzj-ZeCjH4FJa8Z3P6JCXecB0GrU7nUKIIGe5Dex9PbwVrsI4rZO8XWquq~w8qvD5GXZ74Wb~CHs0KmtVASfPUm-UH2bU8gVBTebPDtSyn2cMrRDkvqMlDv5a-ajnxDwct7oQy-XMrLEeSslw4rqGkjhRcOkJyJKK2Ku3JThl-uA8lLjk-qAZpEcNRlbkzWnAlg1BbfyhZuoeWbD~bL2NyDdTFO4~qWJb8No6FyXhVuv9wG4-poEzQHzE9MJgLKcC4~iAwZRnAVWTS64lITeyXAmK5KL4M4s1OCUqWCoF4hZK3HFtOKG~Y-iMlQ-QZjQ__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0px;
  right: 0px;
`;

const PrtnrDropdown = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  border-radius: 999px;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding-bottom: 4px;
  padding-top: 4px;
  padding-left: 4px;
  padding-right: 16px;
`;

const Image = styled.div`
  width: 40px;
  height: 40px;
  position: relative;
`;

const OwlCowboy = styled.div`
  background: url(https://s3-alpha-sig.figma.com/img/3a97/7342/6333d282d0efec6cb08e6b2896737f80?Expires=1748822400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=OMwBhTvD9h7mVnIpbfyeVTk7piIRhu3YdjEoJy8SkpORTjmVApAOsSUri45OLFTlPYtFsT-lv43GsyELFiwDWOZAP6USOEQKEUztBHjgOFDyuyvwcy8ZFBLgPKBpT24UNOfFAqgUH8mHVruXqYxJ8UlTNyjqbXKTRlj50tnFWBtUz5ctn9FMgemguzDSxYcwUFPT1znW9zy6~zOnFTFeclAFq9HQlFY7OaEWhdxl65vHch38jF6Q4jACL09VjvcmshM1wkMzeCEaVZWhboypNJ7CsUoCgA2YsuyADdiEmYxuXKDajQILwdsJOn3kic86~dNFl6IBZv3DiA6TgImefw__),
    rgb(97, 98, 197);
  background-repeat: no-repeat, no-repeat;
  background-size: cover, contain;
  background-position: center, center;
  border-radius: 40px / 40px;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
`;

const JamesD = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 110%;
  text-align: left;
`;

const ChevronDown = styled.svg`
  width: 14px;
  height: 8px;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const AdminMenu = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const ButtonsApp = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 12px 16px;
  flex-shrink: 0;
`;

const ButtonLabel = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`;

const ButtonsApp_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  align-self: stretch;
  background: rgb(97, 98, 197);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 12px 16px;
  flex-shrink: 0;
`;

const ButtonLabel_0001 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`;

const Frame1438 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px 0px 0px;
  flex-shrink: 0;
`;

const Vendors = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 266px;
  min-height: 29px;
  flex: 1;
`;

const Frame1437 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1437_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 266px;
  box-sizing: border-box;
  padding: 16px 0px 0px;
`;

const WebsiteContent = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 268px;
  min-height: 29px;
  flex: 1;
`;

const Admin = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 266px;
  min-height: 29px;
  flex: 1;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const Frame1545 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 766px;
  box-sizing: border-box;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 766px;
  box-sizing: border-box;
`;

const LinkButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const GButtons = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 4px;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 8px 12px;
`;

const IconArrowNarrowLeft = styled.img`
  width: 16px;
  height: 16px;
  object-fit: cover;
`;

const ButtonLabel_0015 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: center;
`;

const MemberStatusTags = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 4px;
  border-radius: 4px;
  width: 96px;
  background: linear-gradient(
    -90deg,
    rgba(18, 124, 78, 0.1),
    rgba(18, 124, 78, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 4px 8px;
`;

const Tracking = styled.span`
  color: rgb(18, 124, 78);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1555 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1552 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 9px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  width: 427px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
`;

const ReferralStatusMember = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 280px;
  min-height: 29px;
`;

const Frame1571 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 9px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Notifiaton1 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 235px;
  box-sizing: border-box;
  padding: 8px;
`;

const Frame1428 = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
`;

const Frame1435 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 179px;
  box-sizing: border-box;
`;

const Frame1545_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2Apr2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const _1010Am = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const Frame1547_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 179px;
  box-sizing: border-box;
`;

const Tracking_0001 = styled.span`
  color: rgb(244, 186, 52);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 181px;
  flex: 1;
`;

const IconPencil01 = styled.img`
  width: 16px;
  height: 16px;
  object-fit: cover;
`;

const ButtonLabel_0016 = styled.span`
  color: rgb(97, 98, 197);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
`;

const Frame1555_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 9px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  width: 427px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
`;

const ReferralStatusVendor = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 280px;
  min-height: 29px;
`;

const _1Apr2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
`;

const Frame1546 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ReferralSubmitted = styled.span`
  color: rgb(89, 84, 222);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const LinkButton_0002 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Frame1558 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame1566 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1565 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 14px;
  box-sizing: border-box;
`;

const Frame1564 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 1px;
  width: 161px;
  box-sizing: border-box;
`;

const Dispute345678 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Created23March2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const DisputeMessage = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  border: solid 1px rgb(225, 228, 234);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame1568 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1566_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 10px;
  box-sizing: border-box;
`;

const Frame1564_0001 = styled.img`
  width: 39px;
  height: 39px;
  object-fit: cover;
`;

const Frame1565_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const JohnnyDepp = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Member = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const _23March20251015Am = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 147px;
`;

const ThisIsAMessageForTheMemberWhoFacedSomeIssuesFromTheReferralsSideHeIsClaimingHisRewardsAndSaysThatAmountReceivedDoesNotMatchTheOneMentionedInTheEmail = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 64px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1559 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 9px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame1581 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 9px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const MemberProfile = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 663px;
  flex: 1;
`;

const Frame1485 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame1538 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 133px;
  box-sizing: border-box;
`;

const ContactPerson = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const JohnnyDepp_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1539 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  box-sizing: border-box;
`;

const ContactNumber = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const _441234567789 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1540 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 205px;
  box-sizing: border-box;
`;

const EmailAddress = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const JamesdoeGmailCom = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1541 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 156px;
  box-sizing: border-box;
`;

const SubmittedOn = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const _1Apr20251010Am = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1485_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1468 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  width: 557px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
`;

const Frame1484 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ReferralsDetails = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 376px;
  min-height: 29px;
  flex: 1;
`;

const Frame1476 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const CompanyWebsite = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const WwwGreenleafcafeCo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1473 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1470 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 255px;
  box-sizing: border-box;
`;

const Sector = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const TechnologySoftwareSaaS = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Location = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const LondonUk = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const DoesYourFriendHaveABudgetToWorkTo = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Unknown = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const IsYouFriendADecisionMaker = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Yes = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const DoesYourFriendHaveAnUrgentProblemOrNeedToAddress = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const SelectedOption = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const InWhatTimeframeWillTheyNeedASolution = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1483_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1483_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const PleaseShareAnyRelevantContextOfYourReferral = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 509px;
  flex: 1;
`;

const Frame1472 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  align-self: stretch;
  height: 186px;
  background: rgb(243, 244, 251);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const AddSomeNotesHere = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 299px;
`;

const Frame1580 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 297px;
  box-sizing: border-box;
`;

const ActivityNotification = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border-radius: 16px;
  align-self: stretch;
  background: linear-gradient(
    -90deg,
    rgba(18, 124, 78, 0.1),
    rgba(18, 124, 78, 0.1)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1583 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1435_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Reward = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 180px;
  flex: 1;
`;

const _200 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 49px;
  min-height: 20px;
`;

const Frame1434 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const AmountAtTheTimeOfSubmission = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 10px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  width: 249px;
  flex: 1;
`;

const SubmittedOn_0001 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const _19January2025181025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Right_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 294px;
  box-sizing: border-box;
`;

const PrtnrInput = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame5 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const FieldLabel = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Field = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Placeholder = styled.span`
  color: black;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 238px;
  flex: 1;
`;

const IconCaretdown = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  flex: none;
  gap: 8px;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
`;

const CaretDown = styled.div`
  width: 9px;
  height: 5px;
  background: url(https://s3-alpha-sig.figma.com/img/46bf/ca2f/25eedd208bc5c58011128405095de699?Expires=1748822400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=n3U0PVkcOJ6DdzqUTV7ItxiHygfetSg1aGLDpXq86PK8ykMj09vPlnYeuON2Ls1D0IyyZGZZ5lZW7Fi8niQwxF~i454XB4XoQKcBnLZCO0ggUj9nNQ8ZmPgD8478rSgXLJy8Brmui6wbhDhxGTgIxrOKOFPLtJEj6P25HFGa0bJLRRLvz2aCNNl~RovLRYw5WZ6HHYeke6KeG07hhzrTMCWqxEQwHFkrsRswzOCddYjzKhklNj6sU3ALPAHPQebp73Z~0bm360XPEBaIVkWGI1Xh2ph9~Zg8ejcKikcf2jk4sWAWtyFwGqroChU2a7X1HPRl33qWH70Ig4VFfKnxUg__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const InternalNotes = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  height: 282px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1433_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  width: 246px;
  box-sizing: border-box;
`;

const InternalNotes_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 248px;
  min-height: 29px;
  flex: 1;
`;

const PrtnrTextarea = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  height: 186px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  align-self: stretch;
  height: 186px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Field_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  border: solid 1px rgb(224, 228, 244);
  border-radius: 8px;
  align-self: stretch;
  height: 186px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Placeholder_0001 = styled.span`
  color: rgb(179, 182, 195);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 215px;
  flex: 1;
`;

const Frame1471_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1484_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1484_0002 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 830px;
  box-sizing: border-box;
`;

const ReferralsDetails_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 832px;
  min-height: 29px;
  flex: 1;
`;

const Frame1485_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px 16px;
  flex-shrink: 0;
`;

const Frame1538_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 300px;
  box-sizing: border-box;
`;

const SubmittedToVendor = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Nesti = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1539_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 300px;
  box-sizing: border-box;
`;

const Frame1551 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _1Apr2025_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const _1010Am_0002 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const ActivityNotification_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  height: 301px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1433_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const History = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 830px;
  min-height: 29px;
  flex: 1;
`;

const ActivitesList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 0px 16px;
  flex-shrink: 0;
`;

const Frame1435_0003 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 790px;
  box-sizing: border-box;
`;

const Frame1519 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 719px;
  box-sizing: border-box;
`;

const StatusChangedTo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const ProposalSent = styled.span`
  color: rgb(244, 186, 52);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Note = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 743px;
  flex: 1;
`;

const Notifiaton1_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  align-self: stretch;
  box-sizing: border-box;
  padding: 8px;
  flex-shrink: 0;
`;

const Frame1435_0004 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 774px;
  box-sizing: border-box;
`;

const Frame1547_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1547_0003 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 774px;
  box-sizing: border-box;
`;

const Tracking_0003 = styled.span`
  color: rgb(244, 186, 52);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 776px;
  flex: 1;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
